import React, { useRef, useState, useEffect } from "react";
import * as echarts from "echarts";

const PieGraph = ({ doughnut = false, option }) => {
  const refPie = useRef();
  const [render, setrender] = useState(false);
  const formatTitle = (title) => {
    return (title + " ").replace(/(\S(.{0,60}\S)?)\s+/g, "$1\n").trim();
  };
  useEffect(() => {
    let chartDom = refPie.current;
    let myChart = echarts.init(chartDom);
    let chartTitle =
      option.title.length > 60 ? formatTitle(option.title) : option.title;
    let configuration = {
      title: {
        text: chartTitle,
        subtext: option.subtitle,
        left: "center",
        subtextStyle: {
          fontWeight: "bolder",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: "{b} : {c} ({d}%)",
      },
      legend: {
        orient: "vertical",
        type: "scroll",
        left: "auto",
        top: 50,
        formatter: function (name) {
          name = name.length > 30 ? name.substring(0, 30) + "..." : name;
          return option.formaterLegent ? option.formaterLegent(name) : name;
        },
        textStyle: {
          fontWeight: "bold",
        },
      },
      series: [
        {
          type: "pie",
          radius: doughnut ? ["35%", "65%"] : "65%",
          label: {
            formatter: "{d}%",
            position: "inside",
            color: "#fff",
          },
          data: option.data,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    configuration && myChart.setOption(configuration);
    setrender(!render);
  }, [option]);
  return (
    <>
      <div
        ref={refPie}
        style={{ width: "800px", height: "300px", margin: "auto" }}
      ></div>
    </>
  );
};

export default PieGraph;
